import { useMemo } from 'react'
import { SelectWrapper } from '../wrapper'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const StatusSelector = ({ onChange, value }) => {
  const { t } = useTranslation()
  const statusOptions = useMemo(() => {
    return [
      { value: 'active', label: 'Activo' },
      { value: 'inactive', label: 'Inactivo' }
    ]
  }, [])

  // Encuentra la opción correspondiente al valor, o null si no hay coincidencia
  const selectedOption = value 
    ? statusOptions.find(statusOption => statusOption.value === value) 
    : null

  const handleChange = (selectedOption) => {
    // Siempre devuelve un objeto con una propiedad 'value'
    onChange({ value: selectedOption ? selectedOption.value : null })
  }

  return (
    <SelectWrapper label='Estado'>
      {(styles) => (
        <Select
          placeholder={t('select.one')}
          loadingMessage={() => t('select.loading')}
          options={statusOptions}
          value={selectedOption}
          styles={styles}
          menuPortalTarget={document.body}
          onChange={handleChange}
          isClearable={true}
        />
      )}
    </SelectWrapper>
  )
}

StatusSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string
}
